import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { putRequest } from "utils/request";

import { i18n } from '../../../translate/i18n';
import { useNotification } from "hooks/notification";
import { getRequest } from "utils/request";

export default function TabDistribution({ companyData }) {
  const [automaticNotifyAndClose, setAutomaticNotifyAndClose] = useState(false);
  const [triesIntervalSetting, setTriesIntervalSetting] = useState(5);
  const [maxTriesSetting, setMaxTriesSetting] = useState(1);
  const [rememberMessageSetting, setRememberMessageSetting] = useState("");
  const [closeMessageSetting, setCloseMessageSetting] = useState("");
  const [needAuth, setNeedAuth] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const value = JSON.stringify(companyData);

    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=RETURNPAUSEPASSWORD`).then(e => {
      if(e.success) {
        if(e.data.id) {
          setNeedAuth(true);
        }
      }
    })
    
    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=CUSTOMERREMENBERINTERVALMESSAGE`).then(e => {
      if(e.success) {
        setRememberMessageSetting(e.data);
      }
    })

    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=CUSTOMERREMENBERCLOSEMESSAGE`).then(e => {
      if(e.success) {
        setCloseMessageSetting(e.data);
      }
    })

    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=CUSTOMERREMENBERINTERVAL`).then(e => {
      if(e.success) {
        setTriesIntervalSetting(e.data);
      }
    })

    getRequest(`/companiessettings?CompanyId=${companyData.id}&code=CUSTOMERREMENBERMAXATTEMPTS`).then(e => {
      if(e.success) {
        setMaxTriesSetting(e.data);
      }
    })

    if (value !== "{}") {
      if (companyData.ticketAutomaticNotifyAndClose) {
        setAutomaticNotifyAndClose(true);
      }
      setLoading(false);
    }
  }, [companyData]);

  const handleDistribution = async (e)  => {
    e.preventDefault();
    setLoading(true);

    if(automaticNotifyAndClose){
      await putRequest(`/companiessettings`, {
        CompanyId: companyData.id,
        code: maxTriesSetting.Setting.code,
        text: maxTriesSetting.text,
        number: maxTriesSetting.number,
      });

      await putRequest(`/companiessettings`, {
        CompanyId: companyData.id,
        code: triesIntervalSetting.Setting.code,
        text: triesIntervalSetting.text,
        number: triesIntervalSetting.number,
      });

      await putRequest(`/companiessettings`, {
        CompanyId: companyData.id,
        code: rememberMessageSetting.Setting.code,
        text: rememberMessageSetting.text,
        number: rememberMessageSetting.number,
      });

      await putRequest(`/companiessettings`, {
        CompanyId: companyData.id,
        code: closeMessageSetting.Setting.code,
        text: closeMessageSetting.text,
        number: closeMessageSetting.number,
      });
    }

    putRequest(`/companies/notify/${companyData.id}`, {
        ticketAutomaticNotifyAndClose: Boolean(automaticNotifyAndClose),
        needAuth: needAuth
      }
    ).then(function () {
        setLoading(false);
      }
    )
  };

  if(loading) {
    return (
      <div className="area-loading">
        <CircularProgress />
      </div>
    )
  }


  return (
    <div className="list-container">
      <form onSubmit={handleDistribution}>
        <div className="form-horizontal">
          <div className="title-helper-container">
            <h3>{companyData.nickName}</h3>
          </div>
          <div className="col-md-12">
            <div className="form-row mt-2">
              <div className="form-group col-md-12 checkbox-container">
                <input
                  checked={automaticNotifyAndClose}
                  onClick={() => setAutomaticNotifyAndClose(!automaticNotifyAndClose)}
                  type="checkbox"
                />
                <label style={{ marginLeft: 10 }}>
                  {i18n.t("enableRememberClient")}
                </label>
              </div>
            </div>
            <div className="form-row mt-2">
              <div className="form-group col-md-12">
                <label> {i18n.t('maxRememberClientTries')} *</label>
                <input
                  type="number"
                  className="form-group"
                  min="1"
                  style={{
                    marginLeft: 5,
                    marginRight: 5,
                    paddingLeft: 5,
                    width: "80px",
                  }}
                  disabled= {!automaticNotifyAndClose}
                  value={automaticNotifyAndClose ? maxTriesSetting.number : ""}
                  onKeyDown={event => { event.preventDefault();}}
                  onChange={(value) => setMaxTriesSetting({...maxTriesSetting , number: Number(value.target.value)})}
                />
              </div>
            </div>
            <div className="form-row mt-2">
              <div className="form-group col-md-12">
                <label> {i18n.t('intervalBetweenRememberClientTries')} *</label>
                <input
                  type="number"
                  step={5}
                  className="form-group"
                  min="5"
                  style={{
                    marginLeft: 5,
                    marginRight: 5,
                    paddingLeft: 5,
                    width: "80px",
                  }}
                  disabled= {!automaticNotifyAndClose}
                  value={automaticNotifyAndClose ? triesIntervalSetting.number : ""}
                  onKeyDown={event => { event.preventDefault();}}
                  onChange={(value) => setTriesIntervalSetting({...triesIntervalSetting, number: Number(value.target.value)})}
                />
              </div>
            </div>

            <div className="form-row mt-2">
              <div className="form-group col-md-3">
                <label>{i18n.t('rememberClientMessage')}</label>
                <textarea
                  type="text"
                  style={{ width: 600 }}
                  rows="3"
                  maxLength={500}
                  className="form-control"
                  disabled= {!automaticNotifyAndClose}
                  value={automaticNotifyAndClose ? rememberMessageSetting.text : ""}
                  onChange={(value) => setRememberMessageSetting({...rememberMessageSetting, text: value.target.value})}
                />
              </div>
            </div>


            <div className="form-row mt-2">
              <div className="form-group col-md-3">
                <label>{i18n.t('automatiCloseTicketMessage')}</label>
                <textarea
                  type="text"
                  style={{ width: 600 }}
                  rows="3"
                  maxLength={500}
                  className="form-control"
                  disabled= {!automaticNotifyAndClose}
                  value={automaticNotifyAndClose ? closeMessageSetting.text : ""}
                  onChange={(value) => setCloseMessageSetting({...closeMessageSetting, text:value.target.value})}
                />
              </div>
            </div>
          </div>
          <div
            className="button-list mt-3 pull-right"
            style={{ position: "absolute", bottom: 0, right: 0 }}
          >
            <button
              type="submit"
              className="btn btn-outline-success"
            >
              <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
